export default "__VITE_ASSET__Bd6iadLU__"